import React, { FC } from "react"
import L10n from "lib/carrot-l10n"
import { FlexRowCenter, Spacer } from "components/views/atoms/Atoms"
import { Body, BodySmall } from "components/views/atoms/Bodies"
import { IlloBlocks } from "../../../atoms/Illustrations"
import { BenefitEnrollmentModalContinueButton } from "../BenefitEnrollmentFlowModal"
import { TextLink } from "../../../atoms/links/TextLink"
import { getCompanyHasCarrotSpecificDeductibleEnabled } from "../../../../../derivedSelectors/deductibleSelectors"
import { useSelector } from "react-redux"
import { Steps } from "../Workflow/Steps"
import { useProgressTracker } from "../../ProgressTracker"
import { useStateMachine } from "../../../../context/stateMachine/StateMachineContext"
import { H2 } from "@carrotfertility/carotene"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()
const ViewName = Steps.INFO_CONNECT_INSURANCE

const InformationalConnectYourInsuranceView: FC = () => {
  const { setNextStep } = useStateMachine(ViewName, null)
  const { setProgress } = useProgressTracker()
  const companyHasCarrotSpecificDeductibleEnabled = useSelector(getCompanyHasCarrotSpecificDeductibleEnabled)

  setProgress(2, "CONNECT YOUR INSURANCE")

  return (
    <div>
      <Spacer height={3} />
      <FlexRowCenter>
        <IlloBlocks />
      </FlexRowCenter>
      <Spacer height={1} />
      <H2 variant="dark">{l`Next, connect your Carrot account with your health insurance provider.`}</H2>
      <Spacer height={0.5} />

      <Body color="black-80">{l`If you have a deductible, Carrot talks to your insurance provider about any out-of-pocket payments you make and submit through Carrot. These payments get added to your other deductible payments, meaning you can pay down your deductible faster.`}</Body>
      <Spacer height={2} />
      {companyHasCarrotSpecificDeductibleEnabled && (
        <div className="fl">
          <TextLink onClick={() => setNextStep(ViewName, "skip")}>
            <BodySmall color="black-80">Skip section</BodySmall>
          </TextLink>
        </div>
      )}
      <div className="fr">
        <BenefitEnrollmentModalContinueButton onClick={() => setNextStep(ViewName, "")} />
      </div>
    </div>
  )
}

export { InformationalConnectYourInsuranceView }
